/**
 * @fileoverview 国际化配置
 * @description 初始化 i18next，配置中英双语支持与自动语言检测
 * @module locales/i18n
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en';
import zh from './zh';

/**
 * 初始化 i18next 国际化配置
 * 支持中文（zh）和英文（en）双语，自动检测浏览器语言
 */
// 读取用户手动设置的语言偏好，未设置时默认英文
const storedLang = localStorage.getItem('augurx_language');
const defaultLang = storedLang && ['zh', 'en'].includes(storedLang) ? storedLang : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      zh: { translation: zh },
      en: { translation: en },
    },
    lng: defaultLang,
    fallbackLng: 'en',
    supportedLngs: ['zh', 'en'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
